import { useTranslation } from 'react-i18next';

interface DocumentTablePaginationProps {
  selectedCount: number;
  totalCount: number;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const DocumentTablePagination = ({
  selectedCount,
  totalCount,
  currentPage,
  totalPages,
  onPageChange,
}: DocumentTablePaginationProps) => {
  const { t } = useTranslation();

  const getPageNumbers = () => {
    return Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
      if (totalPages <= 5) return i + 1;
      if (currentPage <= 3) return i + 1;
      if (currentPage >= totalPages - 2) return totalPages - 4 + i;
      return currentPage - 2 + i;
    });
  };

  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-600">
        {t('documents.table.selection', {
          selected: selectedCount,
          total: totalCount,
        })}
      </span>

      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <button
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className="px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t('documents.table.pagination.previous')}
          </button>

          {getPageNumbers().map((pageNum) => (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`w-8 h-8 text-sm rounded-md ${
                currentPage === pageNum
                  ? 'bg-gray-200 text-gray-900 font-medium'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              {pageNum}
            </button>
          ))}

          <button
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className="px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t('documents.table.pagination.next')}
          </button>
        </div>
      )}
    </div>
  );
};
